import { LitElement, html, css } from 'lit';

export class ProductCatalogTab extends LitElement {
    static properties = {
        contextManager: { type: Object },
        activeContextId: { type: String },
        queryParams: { type: Object },
        contentUrl: { state: true },
        configName: { state: true },
        sku: { state: true },
        disabled: { type: Boolean, reflect: true },
    };

    static styles = css`
        :host {
            display: block;
            padding: 20px;
        }

        :host([disabled]) {
            opacity: 0.5;
            pointer-events: none;
        }

        .container {
            display: flex;
            flex-direction: column;
            gap: 16px;
        }

        .input-row {
            display: flex;
            gap: 16px;
        }
    `;

    constructor() {
        super();
        this.contextManager = null;
        this.activeContextId = null;
        this.queryParams = {};
        this.contentUrl = '';
        this.configName = '';
        this.sku = '';
        this.disabled = true;
    }

    updated(changedProperties) {
        if (changedProperties.has('queryParams')) {
            this.sku = this.queryParams.sku || '';
            this.disabled = !this.sku;
        }

        if (changedProperties.has('activeContextId') && this.activeContextId) {
            this.loadScrapingParameters();
        }
    }

    loadScrapingParameters() {
        if (!this.activeContextId) return;
        const storedParams = localStorage.getItem(`scrapingParams_${this.activeContextId}`);
        if (storedParams) {
            const params = JSON.parse(storedParams);
            this.contentUrl = params.contentUrl || '';
            this.configName = params.configName || '';
        } else {
            this.contentUrl = '';
            this.configName = '';
        }
    }

    render() {
        if (this.disabled) {
            return html`
                <div class="container">
                    <h3>Product Catalog</h3>
                    <p>This tab is disabled. Please provide a 'sku' query parameter to enable it.</p>
                </div>
            `;
        }

        return html`
            <div class="container">
                <h3>Product Catalog</h3>
                <div class="input-row">
                    <sp-textfield
                        label="Content URL"
                        .value=${this.contentUrl}
                        readonly
                    ></sp-textfield>
                    <sp-textfield
                        label="Config Name"
                        .value=${this.configName}
                        readonly
                    ></sp-textfield>
                </div>
                <p>SKU: ${this.sku}</p>
            </div>
        `;
    }
}

customElements.define('product-catalog-tab', ProductCatalogTab); 